import React from 'react';
import { MARKETING_TABS, MARKETING_NAV_TABS } from '../utils/marketingTabs';
import StartLockedDepartmentPage from '../components/start/StartLockedDepartmentPage';

/**
 * Locked preview of the portal Marketing hub (/portal/marketing).
 *
 * No unlock map: every marketing free-page grant points at a page that was
 * retired (the standalone leads calculator now redirects to this hub), so
 * there is no /start sub-page left to hand out.
 */
const StartMarketing = () => (
  <StartLockedDepartmentPage
    title="Marketing"
    tabs={MARKETING_NAV_TABS}
    allTabs={MARKETING_TABS}
  />
);

export default StartMarketing;
